import type { RouteObject } from "src/router";
import { Navigate, useParams } from "src/router";

// Redirect helpers for routes with dynamic params

const EmailRedirect = () => {
  const { emailId } = useParams<{ emailId: string }>();
  return <Navigate to={`/lifecycle-studio/messages/${emailId}`} replace />;
};

const EmailEditRedirect = () => {
  const { emailId } = useParams<{ emailId: string }>();
  return <Navigate to={`/lifecycle-studio/messages/${emailId}/edit`} replace />;
};

const TemplateEmailRedirect = () => {
  const { emailId } = useParams<{ emailId: string }>();
  return <Navigate to={`/lifecycle-studio/templates/${emailId}`} replace />;
};

const CopyDetailRedirect = () => {
  const { copyId } = useParams<{ copyId: string }>();
  return <Navigate to={`/lifecycle-studio/messages/copy/${copyId}`} replace />;
};

const CopyEditRedirect = () => {
  const { copyId } = useParams<{ copyId: string }>();
  return (
    <Navigate to={`/lifecycle-studio/messages/copy/${copyId}/edit`} replace />
  );
};

const ImageRedirect = () => {
  const { imageId } = useParams<{ imageId: string }>();
  return <Navigate to={`/lifecycle-studio/images/${imageId}`} replace />;
};

const IntegrationTypeRedirect = () => {
  const { type } = useParams<{ type: string }>();
  return (
    <Navigate to={`/context-hub/connections/integrations/${type}`} replace />
  );
};

/**
 * All old /content/* routes now redirect to their new /lifecycle-studio/* equivalents.
 */
export const routes: RouteObject[] = [
  // content → /lifecycle-studio/messages
  {
    path: "content",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/messages" replace />,
  },
  // content/generate → /lifecycle-studio/messages/build
  {
    path: "content/generate",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/messages/build" replace />,
  },
  // content/emails → /lifecycle-studio/messages
  {
    path: "content/emails",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/messages" replace />,
  },
  // content/emails/:emailId → /lifecycle-studio/messages/:emailId
  {
    path: "content/emails/:emailId",
    spacesAccess: "hidden-from-limited-view",
    element: <EmailRedirect />,
  },
  // content/emails/:emailId/edit → /lifecycle-studio/messages/:emailId/edit
  {
    path: "content/emails/:emailId/edit",
    spacesAccess: "hidden-from-limited-view",
    element: <EmailEditRedirect />,
  },
  // content/emails/templates → /lifecycle-studio/templates
  {
    path: "content/emails/templates",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/templates" replace />,
  },
  // content/emails/templates/import → /lifecycle-studio/templates/import
  {
    path: "content/emails/templates/import",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/templates/import" replace />,
  },
  // content/emails/templates/:emailId → /lifecycle-studio/templates/:emailId
  {
    path: "content/emails/templates/:emailId",
    spacesAccess: "hidden-from-limited-view",
    element: <TemplateEmailRedirect />,
  },
  // content/emails/copy → /lifecycle-studio/messages (no standalone copy listing)
  {
    path: "content/emails/copy",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/messages" replace />,
  },
  // content/emails/copy/generate → /lifecycle-studio/messages/copy/build
  {
    path: "content/emails/copy/generate",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/messages/copy/build" replace />,
  },
  // content/emails/copy/:copyId → /lifecycle-studio/messages/copy/:copyId
  {
    path: "content/emails/copy/:copyId",
    spacesAccess: "hidden-from-limited-view",
    element: <CopyDetailRedirect />,
  },
  // content/emails/copy/:copyId/edit → /lifecycle-studio/messages/copy/:copyId/edit
  {
    path: "content/emails/copy/:copyId/edit",
    spacesAccess: "hidden-from-limited-view",
    element: <CopyEditRedirect />,
  },
  // content/images → /lifecycle-studio/images
  {
    path: "content/images",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/images" replace />,
  },
  // content/images/:imageId → /lifecycle-studio/images/:imageId
  {
    path: "content/images/:imageId",
    spacesAccess: "hidden-from-limited-view",
    element: <ImageRedirect />,
  },
  // content/settings → /lifecycle-studio/images/tags
  {
    path: "content/settings",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/images/tags" replace />,
  },
  // content/settings/tags → /lifecycle-studio/images/tags
  {
    path: "content/settings/tags",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/images/tags" replace />,
  },
  // content/settings/integrations → /context-hub/connections
  {
    path: "content/settings/integrations",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/context-hub/connections" replace />,
  },
  // content/settings/integrations/:type → /context-hub/connections/integrations/:type
  {
    path: "content/settings/integrations/:type",
    spacesAccess: "hidden-from-limited-view",
    element: <IntegrationTypeRedirect />,
  },
  // content/playground → /lifecycle-studio/messages
  {
    path: "content/playground",
    spacesAccess: "hidden-from-limited-view",
    element: <Navigate to="/lifecycle-studio/messages/playground" replace />,
  },
];
